<template>
  <div class="insight-axis-skeleton">
    <div v-for="index in 3" :key="index" class="block"></div>
  </div>
</template>

<style lang="scss" scoped>
.insight-axis-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;

  // ヒント部分は本体の InsightHintTree と同じく 24px 字下げして、トピックとの階層を見せる
  .block {
    height: 184px;
    border-radius: 4px;
    background: linear-gradient(
      90deg,
      $color-gray200 0%,
      $color-gray200 40%,
      rgba(255, 255, 255, 0.8) 50%,
      $color-gray200 60%,
      $color-gray200 100%
    );
    background-size: 200% 100%;
    animation: shimmer 2.5s linear infinite;

    &:not(:first-child) {
      margin-left: 24px;
    }
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
